import React, { useState } from 'react'

import { CheckCircleOutline, HighlightOff, Edit, ChatBubbleOutline } from '@material-ui/icons'

import { strings } from '@constants'

import {
	Pill,
	ChipRow,
	ChipLine,
	Title,
	CardHeader,
	ApproversRow,
	KeyLabel,
	MetricCard,
	MetricMain,
	StatusCell,
	ActionsCell,
	IconButton,
	CardTopRow,
	ApproversFooter,
} from '../styles'
import Field from './Field'

const chunkIntoPairs = (items = []) => {
	const lines = []
	let current = []
	items.forEach((item) => {
		if (item.fullRow) {
			if (current.length) lines.push(current)
			lines.push([item])
			current = []
			return
		}
		current.push(item)
		if (current.length === 2) {
			lines.push(current)
			current = []
		}
	})
	if (current.length) lines.push(current)
	return lines
}

const ReasonCard = ({ row, reason, onApprove, onReject, onRelatedClick, onInfoClick, hideActions = false, statusTopRight = false }) => {
	const [editing, setEditing] = useState(false)

	const hasApprovers = reason.approvers?.length > 0 || reason.rejections?.length > 0 || reason.pending?.length > 0
	const approvers = hasApprovers && (
		<ApproversRow>
			<KeyLabel>{strings('approvers')} :</KeyLabel>
			{reason.approvers?.map((name, idx) => (
				<Pill key={`approved-${idx}`} color='success' variant='subtle'>
					{name}
				</Pill>
			))}
			{reason.rejections?.map((name, idx) => (
				<Pill key={`rejected-${idx}`} color='error' variant='subtle'>
					{name}
				</Pill>
			))}
			{reason.pending?.map((name, idx) => (
				<Pill key={`pending-${idx}`} color='warning' variant='subtle'>
					{name}
				</Pill>
			))}
		</ApproversRow>
	)

	const content = (
		<>
			<MetricMain>
				<CardHeader>
					<Title>{reason.title}</Title>
					{onInfoClick && (
						<IconButton $color='info' onClick={() => onInfoClick(row, reason)}>
							<ChatBubbleOutline />
						</IconButton>
					)}
				</CardHeader>
				<ChipRow>
					{chunkIntoPairs(reason?.fields).map((line, lineIdx) => (
						<ChipLine key={lineIdx}>
							{line.map((field, idx) => (
								<Field
									key={idx}
									field={field}
									onClick={field.link && onRelatedClick ? () => onRelatedClick(row, reason) : undefined}
								/>
							))}
						</ChipLine>
					))}
				</ChipRow>
			</MetricMain>
			<StatusCell $top={statusTopRight}>
				<Pill color={reason.status.color} variant='subtle'>
					{reason.status.label}
				</Pill>
			</StatusCell>
			{!hideActions && (
				<ActionsCell>
					{reason.isMember &&
						(reason.isPending || editing ? (
							<>
								<IconButton $color='success' onClick={() => onApprove?.(row, reason.key)}>
									<CheckCircleOutline />
								</IconButton>
								<IconButton $color='error' onClick={() => onReject?.(row, reason.key)}>
									<HighlightOff />
								</IconButton>
							</>
						) : (
							<IconButton onClick={() => setEditing(true)}>
								<Edit />
							</IconButton>
						))}
				</ActionsCell>
			)}
		</>
	)

	// approvers sit in their own full-width footer below the fields, status and actions
	return (
		<MetricCard hoverable={false}>
			<CardTopRow>{content}</CardTopRow>
			{approvers && <ApproversFooter>{approvers}</ApproversFooter>}
		</MetricCard>
	)
}

export default ReasonCard
